import { useMutation } from "@tanstack/react-query";

import { dispatchEngagement, type DispatchResponse } from "../api/dispatch";

/**
 * Mutation hook for `POST /api/engagements/{id}/dispatch`.
 *
 * Caller passes the engagement id; the mutation argument is the target
 * phone (must already be in the engagement's allowlist). The hook does
 * NOT swallow errors — components should render the ApiError message
 * so server-side rejections (state mismatch, phone not allowlisted,
 * rate limit, livekit not configured) surface to the operator.
 */
export function useDispatch(engagementId: string) {
  return useMutation<DispatchResponse, Error, string>({
    mutationFn: (targetPhoneE164) =>
      dispatchEngagement(engagementId, targetPhoneE164),
  });
}
